<div *ngIf="comment" class="card">
    <div class="card-header d-flex flex-row align-items-center justify-content-between">
        <div class="d-flex flex-row align-items-center">
            <span class="me-4">{{comment.commenter}}</span>
            <div *ngIf="shouldShowStateTag || !!comment.historic" class="d-flex flex-row align-items-center me-4">
                <span *ngIf="comment.historic==true" class="badge text-light me-1 obs-comment-previouscomment">
                    {{historicLabel}}
                </span>
                <span *ngIf="shouldShowStateTag" class="badge text-light me-1 obs-comment-{{getCommentClass(comment)}}">{{commentState(comment)}}</span>
            </div>
            <div *ngIf="filteredActions?.value | hasNested:CommentTags.Comment" class="d-flex flex-row">
                <ng-template ngFor let-contentRow [ngForOf]="filteredActions?.value | filterNested:CommentTags.Comment">
                    <ng-container [ngTemplateOutlet]="contentRow.templateRef"></ng-container>
                </ng-template>
            </div>
        </div>
        <div>
            <span>{{comment.created | date: "M/d/yyyy hh:mm:ss a"}}</span>
        </div>
    </div>

    <div class="card-body" >
        <div class="mb-2 quill-display" *ngIf="comment.comment" [innerHTML]="sanitizedCommentText"></div>
        <ng-template [permissionsAll]="[PermissionTypes.FILE_ATTACHMENTS]">
            <ng-template ngFor let-f [ngForOf]="comment.attachments">
                <ng-template ngFor let-contentRow [ngForOf]="filteredActions?.value | filterNested:CommentTags.Attachment">
                    <ng-container [ngTemplateOutlet]="contentRow.templateRef" [ngTemplateOutletContext]="{ $implicit: f }"></ng-container>
                </ng-template>
                <div *ngIf="!(filteredActions?.value | hasNested:CommentTags.Attachment)">
                    <i class="fas fa-paperclip text-primary me-1"></i>
                    <span>{{f.fileName}} - {{f.uploadDate | date }}</span>
                </div>
            </ng-template>
        </ng-template>
    </div>
</div>
